import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/custom-statuses/{customStatusId}/unarchive';
type THIS_API = ApiDefinition[typeof PATH_TEMPLATE]['POST'];
type Input = THIS_API['params'];
type Output = THIS_API['response'];

/**
 * Unarchives a previously archived custom status, making it selectable again.
 */
const unarchiveCustomStatus = async ({ customStatusId }: Input): Promise<Output> => {
  const path = buildPath<THIS_API>(PATH_TEMPLATE, { customStatusId });
  const response = await noodleApiClient.post(path);
  return response.data;
};

export default unarchiveCustomStatus;
